// File: frontend/src/api/diccionarioCpvsApi.ts

import { getAuthToken } from "../security/AuthLogin";

const BASE_URL = `${window.location.protocol}//${window.location.hostname}`;
const API_URL = `${BASE_URL}/api`;

/**
 * Lista de CPVs del diccionario con filtros y paginación.
 */
export const fetchDiccionarioCpvs = async (params: {
  [key: string]: string | number | Array<string | number>;
}) => {
  const token = getAuthToken();
  if (!token) {
    window.location.href = "/login";
    throw new Error("Token no encontrado. El usuario no está autenticado.");
  }

  const queryString = new URLSearchParams();
  for (const key in params) {
    const value = params[key];
    if (Array.isArray(value)) {
      value.forEach((val) => queryString.append(key, val.toString()));
    } else {
      queryString.append(key, value.toString());
    }
  }

  const response = await fetch(
    `${API_URL}/diccionario-cpvs?${queryString.toString()}`,
    {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  if (!response.ok) {
    if (response.status === 403 || response.status === 401) {
      localStorage.removeItem("authToken");
      window.location.href = "/login";
      throw new Error("Token expirado o inválido");
    }
    const errorText = await response.text();
    throw new Error(`Error al obtener el diccionario de CPVs: ${errorText}`);
  }

  return response.json(); // { success, data, pagination }
};
